<script setup>
definePage({ meta: { ...PageMeta.Invoices.service.meta, pageTitle: 'Invoice' } })
import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { useInvoiceStore } from '@/@vxapp/Invoices/useInvoiceStore'
import { ServiceType } from '@/@vxapp/@Enums/ServiceType'
import InvoicesServicePage from '@/views/Previews/Invoices/InvoicesServicePage.vue'

const route = useRoute()
const invoiceStore = useInvoiceStore()

useEntityPageTitle({
  entityName: 'Invoice',
  record: () => invoiceStore.invoice,
  recordGuid: invoice => invoice.invoiceGUID,
  identifier: invoice => invoice.id,
})

/** **/
</script>

<template>
  <div
    class="preview-service-wrapper"
    data-testid="service-page-root"
    :data-service-type="ServiceType.Invoices.Name"
  >
    <InvoicesServicePage :key="route.params.guid" />
  </div>
</template>
